const hasRequiredPermissions = ({ permissions, requiredPermissions, hasAtLeastOnePermission }) => {
    const result = [];
    if (requiredPermissions && requiredPermissions.length > 0) {
        requiredPermissions.forEach(requiredPermission => {
            if (permissions && permissions.some(permission => permission === requiredPermission)) {
                result.push(requiredPermission);
            }
        });
        return hasAtLeastOnePermission ? result.length > 0 : result.length === requiredPermissions.length;
    }
    return false;
};
export default hasRequiredPermissions;